import { useState } from "react";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL, NAV_LINKS, LOGO_URL } from "@/config/site";

const Nav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav
      data-testid="site-nav"
      className="border-b border-[#eec643]/30 bg-gradient-to-b from-[#0a1128]/80 to-[#0a1128]/60 backdrop-blur sticky top-0 z-50 shadow-[0_1px_28px_rgba(251,236,93,0.10)]"
    >
      <div className="max-w-7xl mx-auto px-6 h-24 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand-link" className="flex items-center gap-4 shrink-0 mr-10">
          <img
            src={LOGO_URL}
            alt="BGNZN — The Bourganization Institute logo"
            data-testid="nav-logo"
            className="h-14 sm:h-16 w-auto invert hue-rotate-180 drop-shadow-[0_0_14px_rgba(251,236,93,0.35)]"
          />
          <span className="font-extrabold tracking-tight text-xl uppercase text-stone-100 hidden 2xl:inline-block display-serif whitespace-nowrap">
            The Bourganization Institute
          </span>
        </a>
        <div className="hidden lg:flex items-center gap-6 text-sm text-stone-300 whitespace-nowrap">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testid}
              target={link.href.startsWith("http") ? "_blank" : undefined}
              rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
              className="hover:text-[#fbec5d] transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="hidden sm:inline-block px-4 py-2 rounded bg-[#eec643] hover:bg-[#fbec5d] text-[#0a1128] font-semibold text-sm whitespace-nowrap transition-colors shadow-[0_0_20px_rgba(251,236,93,0.3)]"
          >
            Inquire via WhatsApp
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-button"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            className="lg:hidden w-10 h-10 rounded border border-[#1b2a4a] text-stone-200 hover:border-[#eec643]/60 hover:text-[#fbec5d] flex items-center justify-center transition-colors"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden border-t border-[#eec643]/20 bg-[#0a1128]/90 backdrop-blur px-6 py-4 space-y-1"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`mobile-${link.testid}`}
              onClick={() => setMobileOpen(false)}
              className="block py-2.5 text-sm text-stone-300 hover:text-[#fbec5d] transition-colors border-b border-[#1b2a4a]/60 last:border-0"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-whatsapp-cta"
            className="block mt-3 px-4 py-2.5 rounded bg-[#eec643] hover:bg-[#fbec5d] text-[#0a1128] font-semibold text-sm text-center transition-colors"
          >
            Inquire via WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
};

export default Nav;
